import { Box } from "@mantine/core";
import NFTS from "../container/nft/nfts";
import { useLeapSdk } from "../context/sdk";

export default function NFTRoute() {
  const { user } = useLeapSdk();
  if (!user) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flex: 1,
        }}
      >
        <h3>Not logged in</h3>
      </Box>
    );
  }
  return <NFTS />;
}
